/**
 * Cookie utility functions
 * Used to manage cookie consent and settings throughout the application
 */

// Get cookie settings from localStorage
export const getCookieSettings = () => {
  try {
    const settings = localStorage.getItem('cookieSettings');
    return settings ? JSON.parse(settings) : null;
  } catch (error) {
    console.error('Error retrieving cookie settings:', error);
    return null;
  }
};

// Check if a specific type of cookie is allowed
export const isCookieAllowed = (cookieType) => {
  try {
    const settings = getCookieSettings();
    if (!settings) return false;
    return !!settings[cookieType];
  } catch (error) {
    console.error('Error checking cookie permission:', error);
    return false;
  }
};

// Set a cookie with expiration
export const setCookie = (name, value, days) => {
  try {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  } catch (error) {
    console.error('Error setting cookie:', error);
  }
};

// Get a cookie by name
export const getCookie = (name) => {
  try {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  } catch (error) {
    console.error('Error getting cookie:', error);
    return null;
  }
};

// Delete a cookie
export const eraseCookie = (name) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

// Get consent status
export const getConsentStatus = () => {
  return localStorage.getItem('cookieConsent');
}; 